export default __webpack_public_path__ + "static/media/xmas-how.35e2533d.jpg";